import angular from 'angular';

import cmsPopupManagementRouting from './cms-popup-management-routing-module';
import CmsLoginPopupManagementComponent from './cms-popup-management-component';

export default angular
  .module('cms-popup-management', [
    cmsPopupManagementRouting.name,
  ])
  .component('cmsLoginPopupManagement', new CmsLoginPopupManagementComponent());



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/login-popups/cms-popup-management-module.js